@import (reference) '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.input-text {
  font-size: 14px;
  line-height: 20px;
}

.validation-error {
  color: var(--error--message--text-color--2);
}

.field-content {
  display: grid;
  grid-template-columns: calc(100% - 40px) 32px;
  gap: @space-8;

  .first-row {
    grid-row: 1;
  }

  .second-row {
    grid-row: 2;
    margin-top: -8px;
  }

  .third-row {
    grid-row: 3;
    margin-top: -8px;
  }
}

.full-width-content {
  grid-column: 1 / span 2;
}

.field-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  &:hover,
  &:focus {
    border-radius: 4px;
    background: var(--grey-200);
  }
}

.number-input {
  .input-text();
  color: var(--default--text-color--18);

  input {
    width: 100%;
  }
}

.currency-input {
  padding: @space-8;
  height: 32px;
  gap: @space-8;

  &:focus-within {
    border-color: var(--primary--input--focus--border-color--3);
  }

  &.max-value-alert {
    border-color: @curreny-input--border-alert-color;
  }

  input {
    .input-text();
    padding: 0;
  }
}

.currency-input-symbol {
  .input-text();
  padding: 0;
  color: var(--default--icon--fill-color--12);
  z-index: unset;
}

.insurance-promo-header {
  /* prevent an issue with text wrapping */
  font-size: 12.5px;
}
